import React from "react";
import LanguageSwitcher from "../UC/LanguageSwitcher";
import ThemeSwitcher from "../UC/ThemeSwitcher";
import { useTranslation } from "../../contexts/TranslationContext";
import './footer.scss';

const Footer = () => {
    const { language } = useTranslation();

    const version = window.AppVersion || '2357892.00';
    
    return (
        <div className="footer">
            <div className="copyright">
                © 2025 <a href="https://evidenceiq.com/">Evidence IQ.</a>&nbsp;V.1.0.{version}. {language.footer?.allRightsReserved || 'All rights reserved'}.
            </div>
            <div className="socialIcons">
                <a href="https://www.facebook.com/Evidence-IQ-103240888509385" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a>
                <a href="https://twitter.com/EvidenceIQ" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a>
                <a href="https://www.linkedin.com/company/evidence-iq/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                <a href="https://www.youtube.com/@evidenceiq3261" target="_blank" rel="noopener noreferrer" aria-label={language.footer?.visitYouTube || 'Visit our YouTube channel'}><i className="fa fa-youtube-play" aria-hidden="true"></i></a>
            </div>
            <div className="footer-controls">
                <div className="theme-switcher-footer">
                    <ThemeSwitcher showLabel={false} compact={true} />
                </div>
                <div className="language-switcher-footer">
                    <LanguageSwitcher showLabels={false} showFlags={false} compact={false} />
                </div>
            </div>
        </div>
    );
};

export default Footer;